class BaseStrategy {
  constructor({ taskId, supportedClass, commentType, commentTypeConfig, message, commentId = null }) {
    this.taskId = taskId
    this.supportedClass = supportedClass
    this.commentType = commentType
    this.config = commentTypeConfig
    this.message = message
    this.commentId = commentId
  }

  get isEdit() {
    return this.commentId !== null
  }

  get method() {
    return this.isEdit ? 'put' : 'post'
  }

  createBasePayload() {
    return {
      content: this.message
    }
  }

  preparePayloadWithMetadata(base, metadata) {
    const hasMetadata = metadata !== null && Object.keys(metadata).length > 0;

    return {
      ...base,
      ...(hasMetadata && { metadata })
    }
  }
}

class CommonStrategy extends BaseStrategy {
  get url() {
    return this.isEdit ? `comments/${this.commentId}` : 'comments'
  }

  formatPayload(metadata = null) {
    const base = this.createBasePayload()
    const payload = this.preparePayloadWithMetadata(base, metadata)

    return {
      ...payload,
      taskId: this.taskId,
      [this.commentType]: true,
      [this.supportedClass]: true
    }
  }
}

class IntgenStrategy extends CommonStrategy {
  get url() {
    const basePath = `tasks/${this.taskId}/${this.supportedClass}/comments/${this.commentType}`
    return this.isEdit ? `${basePath}/${this.commentId}` : basePath
  }

  formatPayload(metadata = null) {
    const base = this.createBasePayload()
    const payload = this.preparePayloadWithMetadata(base, metadata)

    return {
      ...payload,
      type: this.config?.value
    }
  }
}

const strategyMap = {
  common: CommonStrategy,
  intgen: IntgenStrategy
}

export function createStrategy(serviceType, params) {
  const StrategyClass = strategyMap[serviceType] || CommonStrategy
  return new StrategyClass(params)
}
